import { Link } from "react-router-dom";
import { FadeIn } from "../utils/FadeIn";
import Aggregat from "../images/aggregat.jpg";

/**
 * Modern "vi har en nettbutikk" section — Airon design.
 * Dark card on the left with headline, copy and CTAs; product image + a
 * set of value chips on the right. Replaces the old WebshopIncentives.
 */
export default function WebshopPromo() {
  return (
    <section className="sec" id="nettbutikk" style={{ borderTop: "none" }}>
      <div className="wrap">
        <div className="sec-head">
          <div className="sec-tag">03 / Nettbutikk</div>
          <h2>
            Filter, reservedeler og tilbehør — <em>rett til døren.</em>
          </h2>
          <Link
            to="/produkter"
            className="sec-tag"
            style={{
              color: "var(--airon-3)",
              textDecoration: "none",
              fontFamily: "var(--mono)",
            }}
          >
            Se alle produkter →
          </Link>
        </div>

        <FadeIn>
          <div
            className="webshop-grid"
            style={{
              display: "grid",
              gridTemplateColumns: "1.1fr 0.9fr",
              gap: 24,
              alignItems: "stretch",
            }}
          >
            {/* Left: dark pitch card */}
            <div
              style={{
                background: "var(--ink)",
                color: "#fff",
                borderRadius: 24,
                padding: "48px 44px",
                position: "relative",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <div
                aria-hidden="true"
                style={{
                  position: "absolute",
                  top: -120,
                  right: -120,
                  width: 420,
                  height: 420,
                  borderRadius: "50%",
                  background:
                    "radial-gradient(circle at 30% 30%, var(--airon) 0%, transparent 60%)",
                  opacity: 0.18,
                }}
              />
              <div
                className="sec-tag"
                style={{ color: "var(--airon)", marginBottom: 14 }}
              >
                Vår nettbutikk
              </div>
              <h3
                style={{
                  fontFamily: "var(--display)",
                  fontSize: "clamp(28px, 3.2vw, 40px)",
                  fontWeight: 500,
                  lineHeight: 1.1,
                  letterSpacing: "-0.02em",
                  margin: "0 0 16px",
                }}
              >
                Alt du trenger til ditt ventilasjonsanlegg —{" "}
                <em style={{ fontStyle: "normal", color: "var(--airon)" }}>
                  enkelt å bestille.
                </em>
              </h3>
              <p
                style={{
                  fontSize: 16,
                  color: "#B5C4D3",
                  lineHeight: 1.6,
                  margin: "0 0 28px",
                  maxWidth: "44ch",
                }}
              >
                Filter, reservedeler, kjøkkenhetter, avtrekksvifter,
                kanaldeler og tilbehør. Usikker på hvilket produkt som passer?
                Vi hjelper deg å finne riktig.
              </p>
              <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                <Link to="/produkter" className="btn">
                  Se produkter <span className="arr">→</span>
                </Link>
                <Link
                  to="/produkter/filter"
                  className="btn ghost"
                  style={{
                    color: "#fff",
                    borderColor: "rgba(255,255,255,0.25)",
                    background: "transparent",
                  }}
                >
                  Filter til ditt anlegg
                </Link>
              </div>

              {/* Value chips row */}
              <div
                style={{
                  marginTop: 40,
                  display: "grid",
                  gridTemplateColumns: "repeat(3, 1fr)",
                  gap: 12,
                }}
              >
                <Chip k="01" label="Gratis frakt" value="Over 3 000 kr" />
                <Chip k="02" label="Rask levering" value="1–3 dager" />
                <Chip k="03" label="Fagfolk" value="Support inkludert" />
              </div>
            </div>

            {/* Right: product image tile */}
            <div
              style={{
                borderRadius: 24,
                overflow: "hidden",
                background:
                  "radial-gradient(60% 60% at 50% 40%, rgba(57,182,234,0.18), transparent 70%), linear-gradient(160deg, var(--bg-3), var(--bg-2))",
                border: "1px solid var(--line)",
                padding: 32,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: 360,
              }}
            >
              <img
                src={Aggregat}
                alt="Eksempel på aggregat i Airon-nettbutikken"
                style={{
                  maxWidth: "100%",
                  maxHeight: 380,
                  objectFit: "contain",
                  borderRadius: 16,
                  boxShadow: "0 20px 50px rgba(14,34,51,0.12)",
                }}
              />
            </div>
          </div>
        </FadeIn>
      </div>

      <style>{`
        @media (max-width: 960px) {
          .webshop-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </section>
  );
}

function Chip({ k, label, value }) {
  return (
    <div
      style={{
        background: "rgba(255,255,255,0.04)",
        border: "1px solid rgba(255,255,255,0.08)",
        borderRadius: 14,
        padding: "14px 16px",
      }}
    >
      <div
        style={{
          fontFamily: "var(--mono)",
          fontSize: 10,
          color: "#8da5bc",
          letterSpacing: "0.08em",
          textTransform: "uppercase",
        }}
      >
        {k} / {label}
      </div>
      <div style={{ fontSize: 15, marginTop: 4, color: "#fff" }}>{value}</div>
    </div>
  );
}
